import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import Header from "../../Content/Header/Header";
import { ENABLE_RESONATE_WEBSITE } from "../../../constants/Constants";

class InteractiveMap extends Component {
  componentDidMount() {
    if (!checkCookie("emailId")|| !ENABLE_RESONATE_WEBSITE) {
      this.setState({ redirect: true });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <div className="interactivemap-container">
        <Header />
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 2200 1700">
          <image width="2200" height="1700" xlinkHref="/InteractiveMap.png"></image> 
          <a href="/cotton-candy">
            <rect x="38" y="138" fill="#fff" opacity="0" width="322" height="193"></rect>
          </a>
          <a href="/boba-bites">
            <rect x="363" y="139" fill="#fff" opacity="0" width="364" height="193"></rect>
          </a>
          <a href="/dazzling-designs">
            <rect x="36" y="342" fill="#fff" opacity="0" width="278" height="265"></rect>
          </a>
          <a href="/game-booth">
            <rect x="37" y="613" fill="#fff" opacity="0" width="282" height="269"></rect>
          </a>
          <a href="/masala-mart">
            <rect x="41" y="886" fill="#fff" opacity="0" width="277" height="169"></rect>
          </a>
          <a href="/ethnic-elegance">
            <rect x="62" y="1473" fill="#fff" opacity="0" width="395" height="159"></rect>
          </a>
          <a href="/adorn-adore">
            <rect x="464" y="1474" fill="#fff" opacity="0" width="274" height="160"></rect>
          </a>
          <a href="/kidz-Korner">
            <rect x="741" y="1473" fill="#fff" opacity="0" width="266" height="164"></rect>
          </a>
          <a href="/chaat-cart">
            <rect x="1523" y="135" fill="#fff" opacity="0" width="256" height="153"></rect>
          </a>
          <a href="/snack-shack">
            <rect x="1802" y="225" fill="#fff" opacity="0" width="332" height="378"></rect>
          </a>
          <a href="/biriyani-bazar">
            <rect x="1739" y="609" fill="#fff" opacity="0" width="393" height="314"></rect>
          </a>
          <a href="/tiffin-table">
            <rect x="1741" y="935" fill="#fff" opacity="0" width="388" height="388"></rect>
          </a>
          <a href="/coffee-corner">
            <rect x="1828" y="1411" fill="#fff" opacity="0" width="214" height="215"></rect>
          </a>
          <a href="/crispy-bites">
            <rect x="1528" y="1460" fill="#fff" opacity="0" width="272" height="172"></rect>
          </a>
          <a href="/delightful-drinks">
            <rect x="1043" y="1317" fill="#fff" opacity="0" width="385" height="240"></rect>
          </a>
        </svg>
      </div>
    );
  }
}

export default InteractiveMap;
